import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Briefcase14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.1894 2.25L4.82328 0.616116C5.0577 0.381696 5.37564 0.25 5.70716 0.25H8.29295C8.62447 0.25 8.94241 0.381696 9.17683 0.616117L10.8107 2.25H12.5C13.1904 2.25 13.75 2.80964 13.75 3.5V11.5C13.75 12.1904 13.1904 12.75 12.5 12.75H1.5C0.809644 12.75 0.25 12.1904 0.25 11.5V3.5C0.25 2.80964 0.809645 2.25 1.5 2.25H3.1894ZM5.31072 2.25L5.81072 1.75H8.1894L8.6894 2.25H5.31072ZM1.75 7.35657C3.17176 8.14195 4.6934 8.60705 6.25 8.72191V9.5H7.75V8.72274C9.30679 8.60936 10.8286 8.14434 12.25 7.35787V11.25H1.75V7.35657ZM1.75 5.60468V3.75H12.25V5.60502C10.8319 6.54259 9.3024 7.08562 7.75 7.21806V6.5H6.25V7.21711C4.69774 7.08302 3.16853 6.54021 1.75 5.60468Z'
      fill='currentColor'
    />
  </Svg>
);

Briefcase14.displayName = 'Briefcase14';
export default Briefcase14;
